<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم (اختيار اللجنة والمادة) -->
    <div class="card shadow-sm mb-3 border-top-danger">
      <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 class="mb-0 text-danger fw-bold">
          <i class="fas fa-user-times ms-2"></i> تسجيل الغياب (استلام الأوراق)
        </h5>
        <!-- عداد حي -->
        <div v-if="students.length" class="badge bg-danger fs-6">
           حالات الغياب المسجلة: {{ absentCount }}
        </div>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <!-- الفلاتر -->
          <div class="col-md-3">
            <label class="fw-bold small">الفصل الدراسي</label>
            <select v-model="form.term_id" class="form-select">
              <option v-for="t in terms" :key="t.id" :value="t.id">{{ t.name }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="fw-bold small">اللجنة</label>
            <select v-model="form.committee_id" class="form-select">
              <option v-for="c in committees" :key="c.id" :value="c.id">{{ c.commitee_name }}</option>
            </select>
          </div>
          <!-- المادة (جديد) -->
          <div class="col-md-3">
            <label class="fw-bold small text-danger">المادة (مظروف الإجابة)</label>
            <select v-model="form.subject_id" class="form-select border-danger fw-bold">
              <option value="">-- اختر المادة --</option>
              <option v-for="s in subjects" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select>
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <button @click="fetchStudents" class="btn btn-dark w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              <i class="fas fa-list ms-2"></i> استدعاء الكشف
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. جدول الطلاب وتسجيل الغياب -->
    <div v-if="students.length > 0" class="card shadow-sm">
      
      <!-- شريط أدوات سريع -->
      <div class="card-header bg-light p-2 d-flex justify-content-between align-items-center">
         <span class="text-muted small fw-bold ms-2">عدد الطلاب: {{ students.length }}</span>
         
         <div class="alert alert-warning py-1 px-3 mb-0 small fw-bold border-warning">
            <i class="fas fa-exclamation-triangle me-1"></i> يتم تفعيل الزر أمام الطالب الغائب فقط.
         </div>
         
         <button @click="saveAbsence" class="btn btn-success fw-bold px-4 shadow-sm" :disabled="saving">
            <span v-if="saving" class="spinner-border spinner-border-sm"></span>
            <span v-else><i class="fas fa-save ms-2"></i> حفظ الغياب</span>
         </button>
      </div>

      <div class="table-responsive" style="max-height: 600px; overflow-y: auto;">
        <table class="table table-bordered table-hover text-center align-middle mb-0 sticky-header">
          <thead class="table-dark">
            <tr>
              <th width="10%">م</th>
              <th width="15%">رقم الجلوس</th>
              <th width="40%">اسم الطالب</th>
              <th width="15%">الحالة</th>
              <th width="20%">تسجيل الغياب</th>
            </tr>
          </thead>
          <tbody>
            <tr 
             v-for="(student, index) in students" 
                :key="student.id" 
                :class="{'table-danger': student.is_absent}"
                class="transition-row"
            >
              <td>{{ index + 1 }}</td>
              <td class="fw-bold fs-5 font-monospace">{{ student.Seating_No }}</td>
              <td class="text-start pe-3 fw-bold">{{ student.Arabic_Name }}

                 <div v-if="student.absent_history && student.absent_history.length > 0" class="mt-2">
       <small class="text-muted fw-bold ms-1">سجل الغياب:</small>
       
       <div class="d-flex flex-wrap gap-1 mt-1">
         <span 
           v-for="(subName, i) in student.absent_history" 
           :key="i"
           class="badge bg-secondary text-white border border-light"
           style="font-size: 0.75rem;"
         >
           {{ subName }}
         </span>
       </div>
    </div>
    
              </td>
              
              <!-- عمود الحالة (نصي) -->
              <td>
                <span v-if="student.is_absent" class="badge bg-danger fs-6 shadow-sm">
                  <i class="fas fa-times-circle ms-1"></i> غياب
                </span>
                <span v-else class="badge bg-success fs-6 opacity-75">
                  <i class="fas fa-check-circle ms-1"></i> حضور
                </span>
              </td>

              <!-- زر التبديل (Switch) -->
              <td>
                <div class="form-check form-switch d-flex justify-content-center">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    role="switch" 
                    style="transform: scale(1.7); cursor: pointer;"
                    v-model="student.is_absent "
                    :id="'check-' + student.id"
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- تذييل ثابت للحفظ (في حالة القوائم الطويلة) -->
      <div class="card-footer bg-white py-3 text-center border-top">
         <button @click="saveAbsence" class="btn btn-success btn-lg px-5 fw-bold shadow">
            <i class="fas fa-save ms-2"></i> اعتماد وحفظ الغياب ({{ absentCount }})
         </button>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "AbsenceEntry",
  data() {
    return {
      loading: false,
      saving: false,
      terms: [],
      committees: [],
      subjects: [], // قائمة المواد
      students: [],
      form: {
        term_id: "",
        committee_id: "",
        subject_id: ""
      }
    };
  },
  computed: {
    absentCount() {
      return this.students.filter(s => s.is_absent).length;
    }
  },
  mounted() {
    // تحميل القوائم الأولية
    this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
        // استبدل الروابط بالروابط الحقيقية لديك
        const [resTerms, resComm, resSub] = await Promise.all([
            api.get('/getterms'),
            api.get('/admin/getCommittee'),
            api.get('/getSubject/' + 1) // تأكد من وجود رابط للمواد
        ]);
        this.terms = resTerms.data;
        this.committees = resComm.data;
        this.subjects = resSub.data;
    },

    async fetchStudents() {
      if(!this.form.committee_id || !this.form.subject_id) {
          alert('يرجى اختيار اللجنة والمادة');
          return;
      }
      
      this.loading = true;
      try {
        const res = await api.get('/admin/absence/get-students', { params: this.form });
        // البيانات تأتي ومعها حالة الغياب المسجلة مسبقاً (إن وجدت)
        this.students = res.data;
      } catch (e) {
        console.error(e);
        alert("حدث خطأ في جلب البيانات");
      } finally {
        this.loading = false;
      }
    },

    async saveAbsence() {
      const absentStudents = this.students
          .filter(s => s.is_absent)
          .map(s => s.id); // نرسل IDs الطلاب الغائبين فقط

      // تحذير أمان
      if(!confirm(`سيتم تسجيل غياب لـ (${absentStudents.length}) طالب في هذه المادة. هل أنت متأكد؟`)) return;

      this.saving = true;
      try {
        await api.post('/admin/absence/save', {
            ...this.form, // نرسل المادة والترم
            absent_ids: absentStudents, // قائمة الغائبين
            all_ids: this.students.map(s => s.id) // نرسل كل IDs اللجنة (لتصفير الحضور لمن كان غائباً بالخطأ)
        });
        
        alert("تم حفظ الغياب بنجاح");
      } catch (e) {
        alert("فشل الحفظ");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.border-top-danger { border-top: 4px solid #dc3545; }

/* تأثير عند تغيير الحالة */
.transition-row {
    transition: background-color 0.3s ease;
}
.table-danger {
    background-color: #ffebe9 !important; /* لون أحمر فاتح جداً */
}

/* تثبيت الهيدر */
.sticky-header thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
</style>